<template>
  <div>
    <action-item v-for="(action, index) in actionList" :key="index" :action-item="action" :context-item-id="contextItemId"></action-item>
  </div>
</template>

<script>
import ActionItem from "./ActionItem.vue";

export default {
  name: "ActionList",

  components: { ActionItem },
  props: {
    actionList: {
      required: false,
      default: () => [],
      type: Array
    },
    contextItemId: {
      default: null
    }
  },
  data: () => ({})
};
</script>

<style scoped></style>
